<template>
  <v-dialog
    v-model="value"
    max-width="500"
    class="bar"
    style="pointer-events: none;"
    @keydown.esc="dismiss()"
    persistent
  >
    <v-card style="font-family: 'Prompt' !important">
      <v-card-title style="font-family: 'Prompt' !important">
        {{ $t('upload.upload_image_only') }}
        <v-spacer></v-spacer>
        <v-icon @click="dismiss()" :disabled="isLoading">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-file-input
          ref="fileInput"
          :disabled="isLoading"
          v-model="formData.image"
          accept="image/*"
          @change="uploadImage"
        />
      </v-card-text>
    </v-card>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <ManageImage
      v-model="isManageImageDialog"
      :fileData="fileData"
      @onSuccess="onUploadSuccess"
      @dismiss="dismiss"
    />
  </v-dialog>
</template>
<script>
import { FileUpload } from "@/classes"
import ManageImage from "./ManageImage.vue";
export default {
  props: {
    value: Boolean
  },
  components: {
    ManageImage
  },
  data() {
    return {
      isLoading: false,
      isError: false,
      isManageImageDialog: false,
      fileData: null,
      formData: {
        image: null
      }
    }
  },
  watch: {
    value(){
      setTimeout(() => {
        this.formData = {
          image: null
        }
      }, 200)
    }
  },
  methods: {
    dismiss(){
      this.$emit("input" , false)
    },
    onUploadSuccess(file){
      this.$emit("onSuccess" , file)
      this.dismiss()
    },
    async uploadImage(fileData){
      if(fileData){
        this.fileData = fileData
        this.isManageImageDialog = true
        this.dismiss()
      }
    }
  }
}
</script>